import React, {FC, useCallback} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../libs/shared/helpers/src/types/asyncStatuses';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {GlobalStyles} from '../../../libs/shared/ui/src/styles/globalStyles';
import {center} from '../../../libs/shared/ui/src/styles/mixins';
import {LightUserThemeProvider} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {useClipboard} from '../../helpers/hooks/clipboardHookHelpers';
import {AsyncLoader} from '../common/loaders/asyncLoader';
import {errorFallbackMessage} from './errorFallbackMessage';

/*
 * Style.
 */

const StyledFallbackDiv = styled.div`
  width: 100%;
  height: 100%;

  ${center()};
`;

/*
 * Component.
 */

export interface ErrorUserProps {
  companyId: number;
  userId: number;
  isTopLevel: boolean;
}

interface ErrorFallbackProps extends ErrorUserProps {
  error: Error;
  onRetryClick: Handler;
}

export const ErrorFallback: FC<ErrorFallbackProps> = (props) => {
  const {copy} = useClipboard();
  const {error, companyId, userId, onRetryClick} = props;

  /*
   * Event handlers.
   */

  const onErrorCopyClick = useCallback(() => {
    copy(JSON.stringify({companyId, userId, error, message: error.message, stack: error.stack}));
  }, [companyId, copy, error, userId]);

  /*
   * Render.
   */

  return (
    <LightUserThemeProvider>
      <StyledFallbackDiv>
        <GlobalStyles />
        <AsyncLoader
          size={VisualSizesEnum.LARGE}
          status={AsyncStatusesEnum.FAILED}
          error={errorFallbackMessage}
          onRetryClick={onRetryClick}
        />
        <br />
        <Button onClick={onErrorCopyClick} variant={ButtonVariantsEnum.SECONDARY}>
          Copy diagnostics info
        </Button>
      </StyledFallbackDiv>
    </LightUserThemeProvider>
  );
};
